export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00427.22d945aa.png";